import { Row } from 'components/Layout/Grid';
import Text from 'components/Text';
import { colors } from 'pages/Quotes/styles/colors';

import { GreenDeliveryStyledProps } from './interface';

import styled from 'styled-components';

export const Container = styled.div<GreenDeliveryStyledProps>`
  max-width: ${(props: any) => props.userTypeIsCustomer ? "1100px" : "none"};
  margin:  ${(props: any) => props.userTypeIsCustomer ? "0 auto" : "0 37px 0 10px"};
  padding: ${(props: any) => props.userTypeIsCustomer ? "0.625rem 0 0 0" 
    : props.userTypeIsSupplier ? "3.188rem 0 0 0" : "2.188rem 0 0 0"};
`;

export const Content = styled.div<GreenDeliveryStyledProps>`
    background: linear-gradient(180deg, #FFFFFF 0%, #FFFFFF 100%);
    box-shadow: 0px 3px 3px rgb(0 0 0 / 10%);
    border-radius: 10px;
    align-items: center;

    gap: 20px;
    display: grid;

    grid-template-columns: ${(props: any) => props.userTypeIsCustomer ?
    "180px 335px 250px 235px" : "185px minmax(315px,auto) 300px 300px"};

    padding: 20px 1.25rem;

    @media only screen and (max-width: 1284px) {
      grid-template-columns: 185px minmax(315px,auto) 255px 265px;
    }

    @media only screen and (max-width: 1195px) {
      grid-template-columns: repeat(auto-fit, minmax(190px, auto));
    }

    @media only screen and (max-width: 915px) {
      grid-template-columns: repeat(auto-fit, minmax(275px, auto));
    }

    @media only screen and (max-width: 645px) {
      grid-template-columns: repeat(auto-fit, minmax(190px, auto));
    }
`;

const DefaultText = styled.p`
  font-family: 'Lato';
  font-style: normal;
  font-weight: 400;
  font-size: 13px;
  line-height: 0.875rem;
  letter-spacing: -0.015rem;
`;

export const TextOnLife = styled(DefaultText)`
  color: ${colors.blueDark};
`;

export const LinkDiscoverOurProgram = styled(DefaultText)`
  display: table;
  margin-left: auto;
  padding-top: 1rem;

  color: ${colors.viveoDarkBlue};
  cursor: pointer;
`;

export const Totalizer = styled(Text).attrs({
  size: 40,
  className: "color-blue-gray"
})`
  font-weight: 700;
  line-height: 48px;
  display: block;
`;

export const TotalizerDescription = styled(DefaultText)`
  font-style: italic;
  color: ${colors.viveoBlueText};

  @media only screen and (max-width: 915px){
    width: 160px;
  }

  @media only screen and (max-width: 587px) {
    width: auto;
  }

  @media only screen and (max-width: 465px){
    width: 160px;
  }
`;

export const Pillars = styled.div`
  padding-bottom: 0.625rem;

  ul.list-instructions {
      margin-left: 15px;
      
      li {
        list-style: disc;
        font-size: 14px;

        & + li {
          margin-top: 5px;
        }
      }
    }
`;

export const TextSustainability = styled(Text).attrs(({ padding }) => ({
  size: 14,
  className: `color-oldText ${padding ?? 'pb-2'}`
}))`
  white-space: normal;
`;

export const SustainabilityReport = styled.div`
  width: 100%;
  padding: 1rem 0 1.875rem 0;
`;

export const RowImg = styled(Row)`

  @media only screen and (max-width: 1246px){
    display: grid;
  }

  @media only screen and (max-width: 867px) {
    display: flex;
  }

  @media only screen and (max-width: 623px){
    display: grid;
  }
`;